import { refreshAccessToken as refresh } from 'mycorems-app-accounts';
import router from '../routing/router';

// eslint-disable-next-line import/prefer-default-export
export function refreshAccessToken(): Promise<void> {
  const task = refresh();
  task.catch(() => {
    router.push('/login?redirect=true');
  });
  return task;
}
